import { IPluginsStore } from '../store/pluginsStore';
import { IRootStore } from '../store/rootStore';
import { BlockNormalized, IBlockBase } from '../block/client';
import { TFunctionType } from '../localization';

import { BlockKind } from './common';
import { BlockBaseTypeServer, BlockServer } from './server';
import { normalizeActionPortalOut } from './ActionPortalOut/normalizer';
import { normalizeInputPortalIn } from './InputPortalIn/normalizer';
import { normalizeBase } from './baseNormalizers';

export const normalizeBlockBase = (
  raw: BlockBaseTypeServer,
  { pluginsStore, t }: { pluginsStore: IPluginsStore; t: TFunctionType }
): IBlockBase => ({
  id: raw._id,
  name: raw.name || pluginsStore.blockStaticMap[raw.kind]?.name(t) || '',
  kind: raw.kind,
  bucket: raw.bucket
});

export const normalizeBlock = (
  raw: BlockServer,
  stores: { rootStore: IRootStore }
): BlockNormalized => {
  switch (raw.kind) {
    case BlockKind.portalIn:
      return normalizeInputPortalIn(raw, stores);
    case BlockKind.portalOut:
      return normalizeActionPortalOut(raw, stores);
    default:
      return normalizeBase(raw, stores);
  }
};
